module.exports = __webpack_public_path__ + "static/media/checkgreen.13f2257a.svg";